document.addEventListener('DOMContentLoaded', function () {
    // Inject the overlay div at the end of body
    const overlay = document.createElement('div');
    overlay.className = 'full-screen-overlay';
    document.body.appendChild(overlay);

    function showOverlay() {
        overlay.style.display = 'block';
    }

    function hideOverlay() {
        overlay.style.display = 'none';
    }

    // Full selectors that should NOT trigger the overlay
    const excludedSelectors = [
        '.slick-slide',
        '.slide',
        '.no-overlay',
        '.tab',
        '.mobile-tab-title',
        '.add-video',
        '.add-image',
        '.remove-video',
        '.remove-image',
        '.post-actions a',
        '.floating-menu a',
        '.modal-body a',
        '.tutorial-overlay a',
        '.accordion-title',
        '.site-picker',
        '.open-search',
        '.close-search',
        '.notifications-header-icon',
        '.account-dropdown-link',
        '.floating-menu-holder .toggle',
        '.toolbar a',
        '.expand-card',
        '.messenger a',
        '.conversation-message a',
        '.conversation-accordion-title',
        'form a'
    ];

    // Check if the clicked element or its ancestors match any excluded selector
    function isExcludedClick(element) {
        return excludedSelectors.some(selector => element.closest(selector));
    }

    // Show overlay on all appropriate link clicks
    document.addEventListener('click', function (e) {
        const link = e.target.closest('a');
        if (!link) return;

        if (
            e.ctrlKey || e.metaKey || e.shiftKey ||
            link.target === '_blank' ||
            link.hasAttribute('download')
        ) return;

        if (isExcludedClick(e.target)) return;

        showOverlay();
    });

    // Patch fetch to hide overlay on completion
    if (window.fetch) {
        const originalFetch = window.fetch;
        window.fetch = function (...args) {
            return originalFetch(...args)
                .then(response => {
                    hideOverlay();
                    return response;
                })
                .catch(err => {
                    hideOverlay();
                    throw err;
                });
        };
    }

    // Patch XMLHttpRequest to hide overlay on completion
    (function () {
        const origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (...args) {
            this.addEventListener('loadend', hideOverlay);
            origOpen.apply(this, args);
        };
    })();

    window.addEventListener('pageshow', function (event) {
        // Always hide the overlay on page show (even if from bfcache)
        const overlay = document.querySelector('.full-screen-overlay');
        if (overlay) overlay.style.display = 'none';
    });
});
